/* tslint:disable */
/* eslint-disable */
/**
 * LWM portal
 * Lamb-Weston Meijer Portal API documentation
 *
 * The version of the OpenAPI document: 3.3.11
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { PdfDownloadResponse } from '../model';
// @ts-ignore
import { SalesQuote } from '../model';
/**
 * AgreementsApi - axios parameter creator
 * @export
 */
export const AgreementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve the download link or the sales quote PDF, link will be valid for 5 minutes
         * @summary Get sales quote pdf download link
         * @param {string} id Id of the requested sales quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementsDownloadLinkGet: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('agreementsDownloadLinkGet', 'id', id)
            const localVarPath = `/agreements-download-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns an overview of all agreements of this user
         * @summary Get overview of all agreements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication development-5i2kpscjb65ib9kesn4v8t0121 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "development-5i2kpscjb65ib9kesn4v8t0121", [], configuration)

            // authentication production-65i3ire9nqi9c80lduc24r7rjq required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "production-65i3ire9nqi9c80lduc24r7rjq", [], configuration)

            // authentication staging-6ggnttq03clhsfllacr07d2uit required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "staging-6ggnttq03clhsfllacr07d2uit", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementsApi - functional programming interface
 * @export
 */
export const AgreementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementsApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve the download link or the sales quote PDF, link will be valid for 5 minutes
         * @summary Get sales quote pdf download link
         * @param {string} id Id of the requested sales quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementsDownloadLinkGet(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PdfDownloadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementsDownloadLinkGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns an overview of all agreements of this user
         * @summary Get overview of all agreements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SalesQuote>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AgreementsApi - factory interface
 * @export
 */
export const AgreementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementsApiFp(configuration)
    return {
        /**
         * Retrieve the download link or the sales quote PDF, link will be valid for 5 minutes
         * @summary Get sales quote pdf download link
         * @param {string} id Id of the requested sales quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementsDownloadLinkGet(id: string, options?: any): AxiosPromise<PdfDownloadResponse> {
            return localVarFp.agreementsDownloadLinkGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns an overview of all agreements of this user
         * @summary Get overview of all agreements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementsGet(options?: any): AxiosPromise<Array<SalesQuote>> {
            return localVarFp.agreementsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgreementsApi - object-oriented interface
 * @export
 * @class AgreementsApi
 * @extends {BaseAPI}
 */
export class AgreementsApi extends BaseAPI {
    /**
     * Retrieve the download link or the sales quote PDF, link will be valid for 5 minutes
     * @summary Get sales quote pdf download link
     * @param {string} id Id of the requested sales quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public agreementsDownloadLinkGet(id: string, options?: any) {
        return AgreementsApiFp(this.configuration).agreementsDownloadLinkGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns an overview of all agreements of this user
     * @summary Get overview of all agreements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AgreementsApi
     */
    public agreementsGet(options?: any) {
        return AgreementsApiFp(this.configuration).agreementsGet(options).then((request) => request(this.axios, this.basePath));
    }
}
